import { render, staticRenderFns } from "./CreateQuotations.vue?vue&type=template&id=8ebb5fc2&scoped=true&"
import script from "./CreateQuotations.vue?vue&type=script&lang=js&"
export * from "./CreateQuotations.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuotations.vue?vue&type=style&index=0&id=8ebb5fc2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebb5fc2",
  null
  
)

export default component.exports